// extracted by mini-css-extract-plugin
export var availabilityTag = "post-layout-module--availabilityTag--00037";
export var card = "post-layout-module--card--3dd50";
export var cardHeader = "post-layout-module--cardHeader--5bc31";
export var cardHeaderBlue = "post-layout-module--cardHeaderBlue--fb926";
export var cardHeaderGreen = "post-layout-module--cardHeaderGreen--8b73b";
export var cardHeaderRust = "post-layout-module--cardHeaderRust--3947b";
export var cardHeaderTeal = "post-layout-module--cardHeaderTeal--97eaa";
export var container = "post-layout-module--container--0ec3c";
export var divider = "post-layout-module--divider--8a7cd";
export var feature = "post-layout-module--feature--b8c71";
export var features = "post-layout-module--features--b6cb3";
export var image = "post-layout-module--image--bd725";
export var info = "post-layout-module--info--014d3";
export var modalities = "post-layout-module--modalities--2656c";
export var name = "post-layout-module--name--fc1df";
export var providerGrid = "post-layout-module--providerGrid--fce6c";
export var viewProfileLink = "post-layout-module--viewProfileLink--f790b";